export const ENDPOINTS = {
  FEATURE_FLAGS: '/featureFlags',
} as const;
